export default __webpack_public_path__ + "static/PMG_EGIB_MYRUMAH_PW_AGENCY_ENG-e0e092174ce82bca555f8a4b0f16a44b.pdf";